import {useEffect, useState} from "react";
import {getCustomerIntentSuccess} from "../../common/api/PortalCustomerApi";
import Loading from "../../common/Loading";
import {formatCurrency} from "../../common/Utils";


export default function CartSuccess({paymentId, callback}) {

  const [searchTimer, setSearchTimer] = useState(1);
  const [salesReady, setSalesReady] = useState(false);
  const [salesResp, setSalesResp] = useState();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (paymentId) {
        if (searchTimer > 1) {
          if (searchTimer < 30) {
            getSalesFn(paymentId);
          } else {
            // navigate('#/cx/my-purchases');
          }
        }
      }
    }, 1000);
    return () => clearTimeout(searchTimer);
  }, [searchTimer]);

  const getSalesFn = async (paymentId) => {
    let result = await getCustomerIntentSuccess(paymentId);
    if (result) {
      if (result?.salesItems?.length > 0) {
        setSalesResp(result);
        setSalesReady(true);
        callback('success');
      } else {
        setSearchTimer(searchTimer + 1);
      }
    }
  }

  useEffect(() => {
    getSalesFn(paymentId);
  }, [paymentId]);

  return (
    <div>
      {!salesReady && <><h5 className={'text-center'}>
        Hang tight, finalizing Purchase
      </h5><Loading/></>}
      {salesReady && <><h5
        className={'text-center'}>
        Payment complete!
      </h5>

        {salesResp && salesResp?.salesItems?.length > 0 &&
          <table className="table table-striped mt-2">
            <thead>
            <tr>
              <th scope="col">Item Name</th>
              <th scope="col" className="text-right">Item Price</th>
              <th scope="col" className="text-right">Tax</th>
              <th scope="col" className="text-right">Total</th>
            </tr>
            </thead>
            <tbody>

            {salesResp && salesResp?.salesItems?.sort((a, b) => a.id > b.id ? 1 : -1)
              .map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.itemName}</td>
                    <td className="text-right">{formatCurrency(item.total - item.salesTax)}</td>
                    <td className="text-right">{formatCurrency(item.salesTax)}</td>
                    <td className="text-right">{formatCurrency(item.total)}</td>
                  </tr>
                )
              })
            }

            {salesResp && salesResp?.tipItems?.filter((item)=>item?.total > 0).sort((a, b) => a.id > b.id ? 1 : -1)
              .map((item, index) => {
                return (
                  <tr key={index}>
                    <td>Tip</td>
                    <td className="text-right">&nbsp;</td>
                    <td className="text-right">&nbsp;</td>
                    <td className="text-right">{formatCurrency(item.total)}</td>
                  </tr>
                )
              })
            }

            </tbody>
            <tfoot>
            <tr>
              <td scope="col" colSpan={3}>
                <small>Note: Purchased goods will be available for pick-up in store.</small>
              </td>
              <th scope="col" className="text-right">Total: {formatCurrency(salesResp.totalSales + salesResp.totalTips)}</th>
            </tr>
            </tfoot>
          </table>
        }
      </>}
    </div>

  );
}